// import { Link } from "react-router-dom";

import Homepage from "../components/home/homepage";
import Tentang from "../components/home/tentang";
import Produk from "../components/home/produk";
import Layanan from "../components/home/layanan";
import { HtmlHead } from "../components/HtmlHead";

export default function Home() {
  return (
    <>
      <HtmlHead
        title="Beranda"
        decription="[insert page description]"
        link="/"
      />
      <main className="overflow-hidden">
        <div className="bg-home-small lg:bg-home-big bg-no-repeat bg-scroll lg:bg-auto lg:bg-right-top min-h-screen">
          <Homepage />
          <Tentang />
          <Produk />
          <Layanan />
          {/* <Value /> */}
        </div>
      </main>
    </>
  );
}
